import { __decorate } from 'tslib';
import { NgModule, InjectionToken } from '@angular/core';

let UiBsParameterModule = class UiBsParameterModule {
};
UiBsParameterModule = __decorate([
    NgModule({
        declarations: [],
        imports: []
    })
], UiBsParameterModule);

class ParameterService {
    constructor() {
    }
    static getParam() {
        return ParameterService.parameter;
    }
    static setParam(param) {
        ParameterService.parameter = param;
    }
}
ParameterService.parameter = { device: "APP", config: {} };

const APP_PARAMETER = new InjectionToken('APP_PARAMETER');

const PaginationConfig = {
    DEFAULT_ITEMS_PER_PAGE: 20,
    MAX_ITEMS_PER_PAGE: 100
};
class PaginationParams {
    constructor(page, itemsPerPage) {
        this.page = page;
        this.itemsPerPage = itemsPerPage;
        if (isNaN(this.page) || this.page <= 0)
            this.page = 1;
        if (isNaN(this.itemsPerPage) || this.itemsPerPage <= 0)
            this.itemsPerPage = PaginationConfig.DEFAULT_ITEMS_PER_PAGE;
        if (this.itemsPerPage > PaginationConfig.MAX_ITEMS_PER_PAGE)
            this.itemsPerPage = PaginationConfig.MAX_ITEMS_PER_PAGE;
    }
    get skip() {
        return (this.page - 1) * this.itemsPerPage;
    }
}

export { APP_PARAMETER, PaginationParams, ParameterService, UiBsParameterModule };
//# sourceMappingURL=wlp-ui-bs-parameter.js.map
